import React from 'react';

import { Carousel, Col, Row } from 'react-bootstrap';
import { Tabs } from 'antd';

import './secciones.css'
import useWindowDimensions from '../../../../hooks/Front/windowDimentions/useDimentions';
import { Sticky, StickyContainer } from 'react-sticky';

const { TabPane } = Tabs;

const Galeria = ({ galeria }) => {

    const { width } = useWindowDimensions();


    let margen = width <= 767 ? "130px" : width <= 991 ? "260px" : "198px"

    const renderTabBar = (props, DefaultTabBar) => (
        <Sticky topOffset={-90}>
            {({ style, isSticky }) => (
                <DefaultTabBar {...props} style={{ ...style, zIndex: 100, height: "80px", top: isSticky ? margen : '0px' }} />
            )}
        </Sticky>
    );

    if (!galeria || galeria.length < 1) return null;
    return (
        <StickyContainer>
            <Tabs defaultActiveKey="motor" className="tab-vehiculo" centered id="tab-especificacion" renderTabBar={renderTabBar}>
                {/* <TabPane tab={<h6 className="bold-title-hyundai color-mobile px-lg-5">Tour virtual</h6>} key="tour">
                
                </TabPane> */}
                {galeria && galeria.Exterior && galeria.Exterior.length > 0 &&
                    <TabPane tab={<h5 className="parrafo-hyundai f-18 color-mobile px-lg-5 my-3">Galería Exterior</h5>} key="exterior">
                        <Sliders imagenes={galeria.Exterior} />
                    </TabPane>
                }
                {galeria && galeria.Interior && galeria.Interior.length > 0 &&
                    <TabPane tab={<h5 className="parrafo-hyundai f-18 color-mobile px-lg-5 my-3">Galería Interior</h5>} key="interior">
                        <Sliders imagenes={galeria.Interior} />
                    </TabPane>
                }
            </Tabs>
        </StickyContainer>
    );
};


const Sliders = ({ imagenes }) => {

    if (!imagenes || imagenes.length < 1) return null;
    return (
        <Row>
            <Col>
                <Carousel className="carousel-primario">
                    {imagenes && imagenes.length > 0 && imagenes.map((imagen, i) =>
                        <Carousel.Item key={i}>
                            <img src={imagen.Multimedia} className="img-fluid img-galeria" alt={imagen.Seccion} />
                        </Carousel.Item>
                    )}
                </Carousel>
            </Col>
        </Row>
    )
}

export default Galeria;